import React from "react";
import { Box, Flex, HStack, Separator, Text } from "@commonsku/design-system";

export type AutomationStepTitle = "Triggers" | "Conditions" | "Actions";

export interface AutomationStepPanelProps {
  icon: React.ReactNode;
  title: AutomationStepTitle;
  stepNumber: number;
  children: React.ReactNode;
}

/**
 * Shared card layout for each step in the automation editor.
 */
export const AutomationStepPanel = ({
  icon,
  title,
  stepNumber,
  children,
}: AutomationStepPanelProps) => {
  return (
    <Box
      background="bg.panel"
      borderColor="border.muted"
      borderRadius="md"
      borderStyle="solid"
      borderWidth="1px"
      padding="7"
      width="full"
    >
      <Flex direction="column" gap="2.5">
        <Flex align="center" justify="space-between" width="full">
          <HStack align="center" gap="1">
            {icon}
            <Text fontSize="md" lineHeight="unset" margin="0!">
              {title}
            </Text>
          </HStack>
          <Text color="fg.muted" fontSize="sm" lineHeight="unset" margin="0!">
            Step {stepNumber}
          </Text>
        </Flex>
        <Separator borderColor="border" />
        <Box paddingX="3" paddingY="2">
          {children}
        </Box>
      </Flex>
    </Box>
  );
};

export default AutomationStepPanel;
